import RestService from "./rest.service";

class EvaluateService {
  cycle(type = null) {
    return new Promise((fnResolve, fnReject) => {
      let url = "app/kpi/evaluate/dropdown/cycle"
      if (type) url += '?type=' + type
      RestService.gets(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  listMyEvaluate(kpi_form_id) {
    let link = `app/kpi/evaluate/myevaluate${kpi_form_id !== null && kpi_form_id !== undefined && kpi_form_id !== "" ? `?kpi_form_id=${kpi_form_id}` : ""}`
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(link).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listManageEvaluate() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/manage`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listManageEvaluateCycle(serialCycle) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/manage?cycle=${serialCycle}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  logIsRead(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/log/${serial}/add`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  saveEvaliationDetail(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/save`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  saveEvaliationDetail360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/save`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaliationDetail(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/myEvaluate/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaliationComponent(serial, componentType, ref_id = null) {
    return new Promise((fnResolve, fnReject) => {
      let url = `app/kpi/evaluate/myEvaluate/${serial}/${componentType}`
      if (ref_id) url += '/' + ref_id
      RestService.gets(url).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }


  getEvaliation360Detail(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/360/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaliation360DetailWorkflow(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/360/${serial}/workflow`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getAdminManageEvaliation360Detail(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/evaluate/360/${serial}/manage`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getManageEvaliation360Detail(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/360/${serial}/manage`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaluationAchievements(type, serial, form_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/achievement/${type}/${serial}?form_evaluate_id=${form_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  requestEvaluationStart(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/workflow/evaluate/request`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  submitForm(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/workflow/evaluate/submit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  submitForm360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/submit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  rejectForm(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/workflow/evaluate/reject`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getDetailMoreInfo(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/evaluate/info/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteManageEvaluate360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/kpi/evaluate/360/manage/${data?.form_evaluator_id}?force_completed=${data?.force_completed}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  adminDeleteManageEvaluate360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/evaluate/360/manage/${data?.form_evaluator_id}?force_completed=${data?.force_completed}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  reset360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/evaluate/360/restart`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  submitFormEvaluate360(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/submit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  luanchManageEvaluator(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/360/launch`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  adminLuanchManageEvaluator(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/evaluate/360/launch`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getPreviousEvaluationList(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/kpi/evaluate/previous/my-evaluate`).then(
        (response) => {
          fnResolve(response)
        },
        (response) => {
          fnReject(response)
        }
      )
    })
  }

  getCreateEvaluateJourney(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/admin/evaluationjourney/dropdown/evaluate_template/` + data).then(
        (response) => {
          fnResolve(response)
        },
        (response) => {
          fnReject(response)
        }
      )
    })
  }

  getManagerPreviousEvaluationList(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.get(`app/kpi/evaluate/previous/manager`).then(
        (response) => {
          fnResolve(response)
        },
        (response) => {
          fnReject(response)
        }
      )
    })
  }



  saveFinalGrade(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/evaluate/grade`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}


export default new EvaluateService()
